module.exports = __webpack_public_path__ + "af7825d1d3a3562170b64c41b01adafe.png";